module.exports = __webpack_public_path__ + "static/img/part3.393f1ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gameDetails/NBA2K18/bottom/part3/part3.jpg
// module id = dVJY
// module chunks = 0